<script setup lang="ts">
import { DialogRoot } from 'reka-ui'
</script>

<template>
  <DialogRoot>
    <slot />
  </DialogRoot>
</template>
